import { render, staticRenderFns } from "./CardsContracts.vue?vue&type=template&id=151b8ef8&"
import script from "./CardsContracts.vue?vue&type=script&lang=js&"
export * from "./CardsContracts.vue?vue&type=script&lang=js&"
import style0 from "./CardsContracts.vue?vue&type=style&index=0&id=151b8ef8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports